import React from 'react';

import { styled } from '@mui/material/styles';
import { Box, Button, Grid, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import InteractiveNotFound from 'resources/interactiveNotFound.svg?react';

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 40px);
    justify-content: center;
    width: 100%;
`;

const NotFound = ({ creditId, fromQuote, isLoading }) => {
    const { t } = useTranslation();
    const url = fromQuote
        ? '/applications/quotes'
        : `/credits/file/${creditId}`;

    if (isLoading) return null;

    return (
        <Container>
            <Grid container justifyContent="center">
                <Grid size={{ md: 12, xs: 18 }} textAlign="center">
                    <InteractiveNotFound />
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid
                    size={18}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px',
                    }}
                    textAlign="center"
                >
                    <Typography
                        fontWeight="bold"
                        sx={{ color: '#3a647f', order: { md: 1, xs: 2 } }}
                        variant="h4"
                    >
                        {t('Oops! Contact your Installer!')}
                    </Typography>

                    <Typography
                        fontWeight="bold"
                        sx={{ order: { md: 2, xs: 1 } }}
                        variant="body2"
                    >
                        {t(
                            'Apparently this proposal is no longer valid or has been removed',
                        )}
                    </Typography>
                    <Box sx={{ order: 3 }}>
                        <Button color="secondary" href={url} variant="text">
                            {t('Back')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

NotFound.propTypes = {
    creditId: PropTypes.string,
    fromQuote: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default NotFound;
